module.exports = __webpack_public_path__ + "static/newsApp-c71adde1a34ded28387a1cd49c7ff037.png";